module.exports = __webpack_public_path__ + "img/8-1.34718860.jpg";